import React, { useState, useEffect } from 'react'
import axios from 'axios';
import ModalPreview from './modalPreview';
import FormTip from '../../commons/form_tip';
import {getCsrfToken} from '../../commons/authenticityToken';


interface mPart {
    name: string;
    display_web_name: string;
    display_web_short_name: string;
    description: string;
    is_return_question: boolean;
    gooco_hearing_id: string;
}

interface mPartField {
    id: string;
    name: string;
    display_web_name: string;
    inputtype_kbn: number;
    validate_value_min: number;
    validate_value_max: number;
    display_left: string;
    display_right: string;
    placeholder: string;
    description: string;
    api_output_kbn: number;
    api_field_name: string;
    m_part_code: {name: string, code: string, description: string};
    m_part_field_options: any[];
    is_used: boolean;
    is_answer_required: boolean;
    api_display_left_flag: boolean;
    api_display_right_flag: boolean;
}

interface mPartFieldOption {
    id: string;
    title: string;
    value: string;
    is_option_clear: boolean;
    m_part_field_id: number;
}

const Index = (props) => {
    axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
    
    let mPartTemplate = {
        name: "",
        display_web_name: "",
        display_web_short_name: "",
        description: "",
        is_return_question: false,
        gooco_hearing_id: "",
    } as mPart

    let mPartFieldTemplate = {
        id: "",
        name: "",
        display_web_name: "",
        inputtype_kbn: 1,
        display_left: "",
        display_right: "",
        placeholder: "",
        description: "",
        api_output_kbn: 1,
        api_field_name: "",
        m_part_code: {
            name: "", code: "", description: ""
        },
        m_part_field_options: [],
        is_used: false,
        is_answer_required: false,
        api_display_left_flag: false,
        api_display_right_flag: false
    } as mPartField;

    let mPartFieldOptionTemplate = {
        id: "",
        title: "",
        value: "",
        description: "",
        m_part_field_id: 0,
        is_option_clear: false
    } as mPartFieldOption;

    // Fieldのフォームリスト
    const FormList = 
        [
            { name: "ラジオボタン", value: 1 }, { name: "セレクトリスト", value: 25 }, { name: "チェックボックス", value: 2 }, { name: "インプットエリア（文字）", value: 3 }, 
            { name: "インプットエリア（数字）", value: 5 }, { name: "インプットエリア（小数点）", value: 6 }, { name: "インプットエリア（電話番号）", value: 21 },
            { name: "インプットエリア（日付）", value: 8 }, { name: "テキストエリア", value: 4 }, { name: "画像添付エリア", value: 10 }
        ]
    
    // フォームの説明文
    const formDescription = "患者入力画面で使用する回答方法¥nラジオボタン：単一選択(選択形式)¥nセレクトリスト：単一選択(リスト形式)¥nチェックボックス：複数選択¥nインプットエリア：文字入力１行のみ¥nテキストエリア：文字入力複数行可能¥n画像添付エリア：５枚まで画像データを添付可能"
    // フォーム説明画像
    const radio_button_img =  require("../../../images/tip_radio_button.png");
    const select_list_img =  require("../../../images/tip_select_list.png");
    const checkbox_img =  require("../../../images/tip_checkbox.png");
    const input_img =  require("../../../images/tip_input.png");
    const textarea_img =  require("../../../images/tip_textarea.png");
    const upload_img =  require("../../../images/tip_imgarea.png");

    const formImages = [radio_button_img, select_list_img, checkbox_img, input_img, textarea_img, upload_img]
    

    const viewSupplementaryInformation = [3, 5, 6, 8, 21, 25];
    const viewPlaceholder = [3, 5, 6, 8, 21, 4];
    const viewExplanation = [1, 2, 4, 25];
    const viewOption = [1, 2, 25];
    const viewInitOption = [2];
    const viewValidateNumber = [5, 6];

    // レンダリング用
    const [ update, setUpdate] = useState<Boolean>(false);

    // オプション追加時の連番
    const [ optionAddCount, setOptionAddCount] = useState(1);
    // オプション追加時の連番
    const [ fieldAddCount, setFieldAddCount] = useState(1);

    // テンプレート内容
    const [ part, setPart] = useState<mPart>(mPartTemplate);
    // 特殊質問判定用
    const [ isSpecial, setIsSpecial ] = useState<Boolean>(false);

    // パートフィールドリスト
    const [ partFields, setPartFields ] = useState([]);
    // 選択中のPartFieldId
    const [ checkedPartFiledId, setCheckedPartFiledId ] = useState("");
    // 編集中のオプション
    const [ editPartFieldId, setEditPartFieldId] = useState("");
    // パートフィールド
    const [ partField, setPartField] = useState<mPartField>(mPartFieldTemplate);

    // フィールドオプション
    const [ fieldOptions, setFieldOptions ] = useState([]);
    // 編集中のオプション
    const [ editFieldOption, setEditFieldOption ] = useState(mPartFieldOptionTemplate);
    const [ isFieldOptionUpdate, setIsFieldOptionUpdate] = useState(false);


    // 選択中のオプション
    const [ checkedFiledOptionId, setCheckedFiledOptionId] = useState("");
    // 編集中のオプション
    const [ editFieldOptionId, setEditFieldOptionId] = useState("");
    // エラーメッセージ
    const [errorMessage, setErrorMessage] = useState("");
    // 初回ロード
    useEffect(() =>{
        if (props.is_edit){
            axios.get(
                '/api/internal/parts/edit?id=' + props.m_part_id, {})
                .then(function (response) {
                    setPart(response.data.m_part);
                    setPartFields(response.data.m_part_fields);
                    setIsSpecial(response.data.is_special);
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message);
                });
        }else{
            axios.get(
                '/api/internal/parts/new', {})
                .then(function (response) {
                    setPart(response.data.m_part);
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message);
                }
            )
        }
    },[])
    
    // オプション変更の選択時
    useEffect(() =>{
        const fieldOption = fieldOptions.find(fieldOption => fieldOption.id === editFieldOptionId);
        if(fieldOption){
            setEditFieldOption(fieldOption);
        }else{
            setEditFieldOption(mPartFieldOptionTemplate);
        }
    },[editFieldOptionId])

    // フィールド変更の選択時(モーダル内容セット)
    useEffect(() =>{
        const editPartField = partFields.find(partField => partField.id === editPartFieldId);
        if(editPartField){
            const options = editPartField.m_part_field_options.slice();
            setPartField(editPartField);
            setFieldOptions(options);
        }
    },[editPartFieldId])

    // FieldOptionsが変更時
    useEffect(() => {
        setPartField({...partField, m_part_field_options: fieldOptions});
    },[fieldOptions])

    // 登録・更新処理
    function submitPart(){
        setErrorMessage("");
        if (props.is_edit){
            axios.post(
                '/api/internal/parts/update', {
                    part: part, part_fields: partFields, update_m_user_id: props.current_m_user_id
                })
                .then(function () {
                    location.href = ("/parts/index");
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message)
                });
        }else{
            axios.post(
                '/api/internal/parts/create', {
                    part: part, part_fields: partFields
                })
                .then(function () {
                    location.href = ("/parts/index");
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message)
                });
        }

    }

    // モーダル内の初期化
    function initModalData(){
        setFieldOptions([]);
        const newMPartField = mPartFieldTemplate;
        newMPartField.id = "add" + fieldAddCount;

        const newMPartFieldOption = mPartFieldOptionTemplate;
        newMPartFieldOption.id = "add" + optionAddCount;

        setPartField(newMPartField);
        setEditFieldOption(newMPartFieldOption);
        setCheckedFiledOptionId("");
        setEditFieldOptionId("");
        setEditPartFieldId("");
        setIsFieldOptionUpdate(false);
        // 編集を考慮してaddCountは初期化しない
        setUpdate(update?false:true);
    }

    // パートフィールド追加
    function addPartField(){
        const partFiledDup = partFields;
        partFiledDup.push(partField);
        setPartFields(partFiledDup);
        setFieldAddCount(fieldAddCount + 1);
        initModalData();
        setUpdate(update?false:true);
    }

    // パートフィールド更新
    function updatePartField(){
        const partFiledDup = partFields;
        const index = partFields.findIndex( (partField) => partField.id === editPartFieldId)
        partFiledDup[index] = partField;
        setPartFields(partFiledDup);
        initModalData();
        setUpdate(update?false:true);
    }

    // Part削除
    function removePartFiled(){
        setPartFields(partFields.filter(part => part.id !== checkedPartFiledId));
        setCheckedPartFiledId("");
    }

    // option削除
    function removePartFieldOption(){
        setFieldOptions(fieldOptions.filter(fieldOption => fieldOption.id !== checkedFiledOptionId));
        setCheckedFiledOptionId("");
    }

    // カテゴリ移動
    function optionMoveRow(type){
        if(checkedFiledOptionId === "") return;

        const fieldOptionsDup = fieldOptions.slice();
        const targetIndex = fieldOptionsDup.findIndex(fieldOption => fieldOption.id === checkedFiledOptionId)

        switch(type){
            case "up":
                if(targetIndex === 0) return;
                fieldOptionsDup.splice( targetIndex - 1, 2, fieldOptionsDup[targetIndex], fieldOptionsDup[targetIndex - 1]);
                break;
            case "down":
                if(targetIndex === (fieldOptions.length - 1)) return;
                fieldOptionsDup.splice( targetIndex, 2, fieldOptionsDup[targetIndex + 1], fieldOptionsDup[targetIndex]);
                break;
        }
        setFieldOptions(fieldOptionsDup);
    }

    // カテゴリ移動
    function moveRow(type){
        if(checkedPartFiledId === "") return;

        const partsDup = partFields.slice();
        const targetIndex = partsDup.findIndex(part => part.id === checkedPartFiledId)

        switch(type){
            case "up":
                if(targetIndex === 0) return;
                partsDup.splice( targetIndex - 1, 2, partsDup[targetIndex], partsDup[targetIndex - 1]);
                break;
            case "down":
                if(targetIndex === (partFields.length - 1)) return;
                partsDup.splice( targetIndex, 2, partsDup[targetIndex + 1], partsDup[targetIndex]);
                break;
        }
        setPartFields(partsDup);
    }

    function changeCheckedPartFiledId(value){
        setCheckedPartFiledId(value);
        setUpdate(update?false:true);
    }

    function changeCheckedOptionId(value){
        setCheckedFiledOptionId(value);
        setUpdate(update?false:true);
    }



    // オプション追加
    function addFieldOption(){
        const fieldOptionsDup = fieldOptions;
        let newMPartFieldOption = mPartFieldOptionTemplate;
        newMPartFieldOption.id = "add" + optionAddCount;
        
        fieldOptionsDup.push(newMPartFieldOption);
        setFieldOptions(fieldOptionsDup);
        setEditFieldOptionId("add"+ optionAddCount);
        setCheckedFiledOptionId("add"+ optionAddCount);
        setOptionAddCount(optionAddCount + 1);

        // 再レンダリング
        setUpdate(update?false:true);
    }

    // オプション適用
    function changeEditFieldOption(){
        setFieldOptions(
            fieldOptions.map((fieldOption) => fieldOption.id === editFieldOptionId ? 
            {id: fieldOption.id, title: editFieldOption.title, value: editFieldOption.value, m_part_field_id: fieldOption.m_part_field_id, is_option_clear: editFieldOption.is_option_clear}
            :
            {id: fieldOption.id, title: fieldOption.title, value: fieldOption.value, m_part_field_id: fieldOption.m_part_field_id, is_option_clear: fieldOption.is_option_clear})
        );
        setEditFieldOptionId("");
        setIsFieldOptionUpdate(true);
        // 再レンダリング
        setUpdate(update?false:true);
    }

    // モーダル閉じる
    function closeModal(){
        const backUpPartField = partFields.find(partField => partField.id === editPartFieldId);
        const beforePartField = Object.entries(backUpPartField).sort().toString();
        const afterPartField = Object.entries(partField).sort().toString();

        // PartFieldもしくはオプションに差異があった場合
        if (beforePartField != afterPartField || isFieldOptionUpdate){
            const result = window.confirm("変更箇所があります。\r\n反映せずに閉じてもよろしいですか？");
            if (result) {
                initModalData();
                document.getElementById("close-modal").click();
            }
        }else{
            initModalData();
            document.getElementById("close-modal").click();
        }
    }

  // 表示切り替え
  function changeApiDisplayLeftFlag(checked){
    setPartField({...partField, api_display_left_flag: checked});
  }

  // 表示切り替え
  function changeApiDisplayRightFlag(checked){
    setPartField({...partField, api_display_right_flag: checked});
  }

    return(
        <>
            { errorMessage && 
                <div className="alert alert-danger alert-dismissible" role="alert">
                    <button 
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="閉じる">
                            <span aria-hidden="true">×</span>
                    </button>
                        {
                            errorMessage
                        }
                </div>
            }
            <div className="row">
                <div className="col-md-2 col-lg-3"/>
                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6">
                    <div className="form-group">
                        <a className="btn btn-primary pull-right m5" data-toggle="modal" data-target="#preview_modal">プレビュー</a>
                    </div>
                    
                    <div className="form-group">
                        <FormTip description="質問文に名前をつけてください">
                            <label htmlFor="m_part_name">質問名</label><span className="label label-danger ml5">必須</span>
                        </FormTip>
                        <input 
                            className="form-control" 
                            placeholder="例：患者氏名" 
                            type="text" 
                            id="m_part_name"
                            defaultValue={part.name}
                            value={part.name}
                            onChange={(e) => setPart({...part, name: e.target.value})}
                        />
                    </div>

                    <div className="form-group">
                        <FormTip description="患者への問いかけ">
                            <label htmlFor="m_part_display_name">質問文</label><span className="label label-danger ml5">必須</span>
                        </FormTip>
                        <input 
                            className="form-control" 
                            placeholder="例：お名前は？" 
                            type="text" 
                            id="m_part_display_name"
                            defaultValue={part.display_web_name}
                            value={part.display_web_name}
                            onChange={(e) => setPart({...part, display_web_name: e.target.value})}
                        />
                    </div>

                    <div className="form-group">
                        <FormTip description="患者入力画面に表示される際、質問名と別名称にする場合は設定してください">
                            <label htmlFor="m_part_short_name">質問名（患者画面）</label>
                        </FormTip>
                        <input 
                            className="form-control" 
                            placeholder="例：お名前" 
                            type="text" 
                            id="m_part_short_name"
                            defaultValue={part.display_web_short_name}
                            value={part.display_web_short_name}
                            onChange={(e) => setPart({...part, display_web_short_name: e.target.value})}
                        />
                    </div>

                    <div className="form-group">
                        <FormTip description="管理画面で表示される説明文">
                            <label htmlFor="m_part_description">質問詳細</label>
                        </FormTip>
                        <textarea 
                            rows={3}
                            className="form-control" 
                            placeholder="質問詳細を入力してください"
                            id="m_part_description"
                            defaultValue={part.description}
                            value={part.description}
                            onChange={(e) => setPart({...part, description: e.target.value})}
                        />
                    </div>
                    { !props.is_edit && 
                        <div className="form-group">
                            <label>質問の種類</label><span className="label label-danger ml5">必須</span>
                            <br/>
                            <div className="radio-inline">
                                <input 
                                    className="radio-input"
                                    type="radio"
                                    value="false"
                                    id="m_part_return_question_false"
                                    name="m_part_return_question"
                                    onChange={(e) => setPart({...part, is_return_question: false})}
                                    defaultChecked={ part.is_return_question === false }
                                    disabled={props.is_edit}
                                />
                                <label className="m10" htmlFor="m_part_return_question_false">新患／再来向け</label>                            
                                <input 
                                    className="radio-input" 
                                    type="radio" 
                                    value="true"
                                    id="m_part_return_question_true" 
                                    name="m_part_return_question"
                                    onChange={(e) => setPart({...part, is_return_question: true})}
                                    defaultChecked={ part.is_return_question === true }
                                    disabled={props.is_edit}
                                />
                                <label className="m10" htmlFor="m_part_return_question_true">再来向け</label>
                            </div>
                        </div>
                    }


                    <div className="form-group">
                        <FormTip description="GooCo連携時に対象のヒアリングIDに質問が紐付きGooCo側に表示されます">
                            <label htmlFor="m_part_gooco_hearing_id">GooCo先確認ID</label>
                        </FormTip>
                        <input 
                            className="form-control" 
                            placeholder="0001" 
                            type="text" 
                            id="m_part_gooco_hearing_id"
                            defaultValue={part.gooco_hearing_id}
                            value={part.gooco_hearing_id}
                            onChange={(e) => setPart({...part, gooco_hearing_id: e.target.value})}
                        />
                    </div>

                    {/* 質問設定内容 */}
                    <div className="form-group">
                        <FormTip description="質問に対する回答フォームを設定します">
                            <label htmlFor="m_part_fields">回答設定</label><span className="label label-danger ml5">必須</span>
                        </FormTip>
                        {
                            !isSpecial &&
                            <>
                                <div className="text-left col-md-6 col-sm-6 col-xs-6 part-add">
                                    {
                                        (checkedPartFiledId != "") && 
                                            <>
                                                <a className="btn btn-primary mr10" onClick={()=> moveRow('up')}>▲</a>
                                                <a className="btn btn-primary mr10" onClick={()=> moveRow('down')}>▼</a>
                                                <a className="btn btn-primary mr10" data-toggle="modal" data-target="#myModal" onClick={() => setEditPartFieldId(checkedPartFiledId)}>編集</a>
                                            </>
                                        
                                    }
                                </div>
                                <div className="text-right col-md-6 col-sm-6 col-xs-6 part-add">
                                    <a className="btn btn-primary mr10" data-toggle="modal" data-target="#myModal"　onClick={() => initModalData()}>追加</a>
                                    {(checkedPartFiledId != "") && <a className="btn btn-danger mr10" onClick={()=> removePartFiled()}>削除</a>}
                                </div>
                            </> 
                        }

                        
                        <table id="m_part_filed_table" className="table table-bordered">
                            <thead>
                                <tr className="success">
                                    <th className="col-md-12 col-sm-12 col-xs-12 text-center">子質問名</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    partFields.map((partFiled) => {
                                        const isChecked = partFiled.id === checkedPartFiledId;
                                        return(
                                        <tr className={isChecked && "select-part-group"} onClick={() => changeCheckedPartFiledId(partFiled.id)}>
                                            <td>{partFiled.name}</td>
                                        </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>
                    </div>

                    {/* ボタン類 */}
                    <div>
                        <div className="actions mt40">
                            <a className="btn btn-primary pull-left m5" href="/parts/index">戻る</a>
                            <a className="btn btn-primary pull-right m5" onClick={() => submitPart()}>
                                {(props.is_edit) ? ("更新する") : ("作成する") }
                            </a>
                        </div>
                    </div>
                </div>   
            </div>
            
            {/* モーダル */}
            <div id="myModal" className="modal fade" data-keyboard="false" data-backdrop="static" role="dialog">
                <div className="modal-dialog videocall-modal">
                    <div className="modal-content">
                        <div className="modal-header text-center bg-success">
                            <h4 className="modal-title text-center">質問項目を設定してください</h4>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <FormTip description="子質問(詳細な情報を聞き取るために設定する質問文)に名前をつけてください">
                                    <label htmlFor="m_part_field_name">子質問名</label><span className="label label-danger ml5">必須</span>
                                </FormTip>
                                <input 
                                    className="form-control" 
                                    placeholder="例：体重フォーム" 
                                    type="text" 
                                    id="m_part_field_name"
                                    defaultValue={partField.name}
                                    value={partField.name}
                                    onChange={(e) => setPartField({...partField, name: e.target.value})}
                                />
                            </div>

                            <div className="form-group">
                                <FormTip description="患者への問いかけ">
                                    <label htmlFor="m_part_field_display_web_name">子質問文</label>
                                </FormTip>
                                <input 
                                    className="form-control" 
                                    placeholder="例：体重を入力してください" 
                                    type="text" 
                                    id="m_part_field_display_web_name" 
                                    defaultValue={partField.display_web_name}
                                    value={partField.display_web_name}
                                    onChange={(e) => setPartField({...partField, display_web_name: e.target.value})}
                                />
                            </div>

                            <div className="form-group">
                                <FormTip description={formDescription} images={formImages}>
                                    <label htmlFor="m_part_field_input_type">回答フォーム種別</label><span className="label label-danger ml5">必須</span>
                                </FormTip>
                                <select className="form-control" id="m_part_field_input_type" onChange={(e) => setPartField({...partField, inputtype_kbn: Number(e.target.value)})} disabled={partField.is_used}>
                                    {
                                        FormList.map((form)=>{
                                            return(
                                                <>
                                                    {
                                                        partField.inputtype_kbn === form.value ?
                                                            <option value={form.value} selected>{form.name}</option>
                                                            :
                                                            <option value={form.value}>{form.name}</option>
                                                        
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </select>
                            </div>

                            <div className="form-group">
                                <FormTip description="患者へ必ず回答してほしい項目に設定">
                                    <label htmlFor="m_part_field_display_web_name">回答必須にする</label>
                                </FormTip>
                                <div className="radio-inline">
                                    <input 
                                        className="radio-input" 
                                        type="radio" 
                                        value={1}
                                        id="is_answer_required_1" 
                                        name="is_answer_required"
                                        defaultChecked={partField.is_answer_required === false}
                                        checked={partField.is_answer_required === false}
                                        onChange={(e) => setPartField({...partField, is_answer_required: false})}
                                    />
                                    <label className="m10" htmlFor="is_answer_required_1">OFF</label>
                                    <input 
                                        className="radio-input"
                                        type="radio"
                                        value={0}
                                        id="is_answer_required_0"
                                        name="is_answer_required"
                                        defaultChecked={partField.is_answer_required === true}
                                        checked={partField.is_answer_required === true}
                                        onChange={(e) => setPartField({...partField, is_answer_required: true})}
                                    />
                                    <label className="m10" htmlFor="is_answer_required_0">ON</label>
                                </div>
                            </div>
                            {
                                viewValidateNumber.includes(partField.inputtype_kbn) && (
                                    <>
                                        <div className="form-group">
                                            <FormTip description="先確認で表示される回答フォームの下限値">
                                                <label htmlFor="m_part_field_validate_value_min">回答フォームの下限値</label>
                                            </FormTip>
                                            <input 
                                                className="form-control" 
                                                placeholder="0" 
                                                type="number"
                                                id="m_part_field_validate_value_min" 
                                                defaultValue={partField.validate_value_min}
                                                value={partField.validate_value_min}
                                                onChange={(e) => setPartField({...partField, validate_value_min: Number(e.target.value)})}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <FormTip description="先確認で表示される回答フォームの上限値">
                                                <label htmlFor="m_part_field_validate_value_max">回答フォームの上限値</label>
                                            </FormTip>
                                            <input 
                                                className="form-control" 
                                                placeholder="999" 
                                                type="number"
                                                id="m_part_field_validate_value_max" 
                                                defaultValue={partField.validate_value_max}
                                                value={partField.validate_value_max}
                                                onChange={(e) => setPartField({...partField, validate_value_max: Number(e.target.value)})}
                                            />
                                        </div>
                                    </>
                                )
                            }
                            {
                                viewSupplementaryInformation.includes(partField.inputtype_kbn) &&(
                                <>
                                    <div className="form-group">
                                        <FormTip description="先確認で表示される回答フォームの左側に表示される補足事項">
                                            <label htmlFor="m_part_field_display_left">回答フォーム補足事項（左）</label>
                                        </FormTip>
                                          <label className="col-md-3 pr0 pl0">GooCo連携時に表示</label>
                                          <div className="col-md-1 pr0 pl0">
                                            <div className="switchArea">
                                              <input className="check" value={"true"} type="checkbox" id={"api_display_left"}  defaultChecked={partField.api_display_left_flag === true} onChange={(e) => changeApiDisplayLeftFlag(e.target.checked)}/>
                                              <label className="check-label" htmlFor={"api_display_left"}>
                                                <span/>
                                              </label>
                                              <label htmlFor={"api_display_left"} id="swImg" />
                                            </div>
                                          </div>
                                        <input 
                                            className="form-control" 
                                            placeholder="例：体重：" 
                                            type="text" 
                                            id="m_part_field_display_left" 
                                            defaultValue={partField.display_left}
                                            value={partField.display_left}
                                            onChange={(e) => setPartField({...partField, display_left: e.target.value})}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <FormTip description="先確認で表示される回答フォームの右側に表示される補足事項">
                                            <label htmlFor="m_part_field_display_right">回答フォーム補足事項（右）</label>
                                        </FormTip>
                                        <label className="col-md-3 pr0 pl0">GooCo連携時に表示</label>
                                          <div className="col-md-1 pr0 pl0">
                                            <div className="switchArea">
                                              <input className="check" value={"true"} type="checkbox" id={"api_display_right"}  defaultChecked={partField.api_display_right_flag === true} onChange={(e) => changeApiDisplayRightFlag(e.target.checked)}/>
                                              <label className="check-label" htmlFor={"api_display_right"}>
                                                <span/>
                                              </label>
                                              <label htmlFor={"api_display_right"} id="swImg" />
                                            </div>
                                          </div>
                                        <input 
                                            className="form-control" 
                                            placeholder="例：kg" 
                                            type="text" 
                                            id="m_part_field_display_right" 
                                            defaultValue={partField.display_right}
                                            value={partField.display_right}
                                            onChange={(e) => setPartField({...partField, display_right: e.target.value})}
                                        />
                                    </div>
                                </>
                            )}
                            
                            { viewPlaceholder.includes(partField.inputtype_kbn) && (
                                <div className="form-group">
                                    <FormTip description="先確認で表示される回答フォーム内のプレースホルダの内容">
                                        <label htmlFor="m_part_field_placeholder">プレースホルダ</label>
                                    </FormTip>
                                    <input 
                                        className="form-control" 
                                        placeholder="例：10" 
                                        type="text" 
                                        id="m_part_field_placeholder"
                                        defaultValue={partField.placeholder}
                                        value={partField.placeholder}
                                        onChange={(e) => setPartField({...partField, placeholder: e.target.value})}
                                    />
                                </div>
                            )}

                            { viewExplanation.includes(partField.inputtype_kbn) && (
                                <div className="form-group">
                                    <FormTip description="回答フォームについての補足説明">
                                        <label htmlFor="m_part_field_description">回答フォーム説明</label>
                                    </FormTip>
                                    <textarea 
                                        rows={3}
                                        className="form-control" 
                                        placeholder="部品の説明を入力してください"
                                        id="m_part_field_description"
                                        defaultValue={partField.description}
                                        value={partField.description}
                                        onChange={(e) => setPartField({...partField, description: e.target.value})}
                                    />
                                </div>
                            )}

                            <div className="form-group">
                                <FormTip description="GooCoに転記する際、回答と一緒に質問タイトルも記載する場合ONに設定してください。※子質問が多い場合はON推奨">
                                    <label>GooCoタイトル表示</label><span className="label label-danger ml5">必須</span>
                                </FormTip>
                                <div className="radio-inline">
                                    <input 
                                        className="radio-input" 
                                        type="radio" 
                                        value={1}
                                        id="api_out_kbn_1" 
                                        name="api_out_kbn"
                                        defaultChecked={partField.api_output_kbn === 1}
                                        checked={partField.api_output_kbn === 1}
                                        onChange={(e) => setPartField({...partField, api_output_kbn: 1})}
                                    />
                                    <label className="m10" htmlFor="api_out_kbn_1">OFF</label>
                                    <input 
                                        className="radio-input"
                                        type="radio"
                                        value={0}
                                        id="api_out_kbn_0"
                                        name="api_out_kbn"
                                        defaultChecked={partField.api_output_kbn === 0}
                                        checked={partField.api_output_kbn === 0}
                                        onChange={(e) => setPartField({...partField, api_output_kbn: 0})}
                                    />
                                    <label className="m10" htmlFor="api_out_kbn_0">ON</label>
                                </div>
                            </div>

                            {/* API出力区分で表示切り替え */}
                            {partField.api_output_kbn === 0 &&
                                <div className="form-group">
                                    <FormTip description="GooCoの回答で表示されるタイトル表示名">
                                        <label htmlFor="api_field_name">GooCoタイトル表示名</label>
                                    </FormTip>
                                    <input 
                                        className="form-control" 
                                        placeholder="体重：" 
                                        type="text" 
                                        id="api_field_name"
                                        defaultValue={partField.api_field_name}
                                        value={partField.api_field_name}
                                        onChange={(e) => setPartField({...partField, api_field_name: e.target.value})}
                                    />
                                </div>
                            }

                            { viewOption.includes(partField.inputtype_kbn) &&
                                <div className="part-group-table-wrapper">
                                    { !partField.is_used &&
                                        <>
                                            <div className="text-left col-md-6 col-sm-6 col-xs-6 part-add">
                                                {
                                                <>
                                                    {(editFieldOptionId === "" && checkedFiledOptionId) && 
                                                        <>
                                                            <a className="btn btn-primary mr10" onClick={()=> optionMoveRow('up')}>▲</a>
                                                            <a className="btn btn-primary mr10" onClick={()=> optionMoveRow('down')}>▼</a>
                                                        </>
                                                    }
                                                    {
                                                        (editFieldOptionId != "") ? (
                                                            <>
                                                                <a className="btn btn-primary mr10" onClick={() => changeEditFieldOption()}>適用</a>
                                                                <a className="btn btn-danger mr10" onClick={() => setEditFieldOptionId("")}>キャンセル</a>
                                                            </>
                                                        ) : (
                                                            checkedFiledOptionId && <a className="btn btn-primary mr10" onClick={() => setEditFieldOptionId(checkedFiledOptionId)}>編集</a>
                                                        )
                                                    }
                                                </>
                                                }
                                            </div>
                                            <div className="text-right col-md-6 col-sm-6 col-xs-6 part-add">
                                                {(editFieldOptionId === "") && <a className="btn btn-primary mr10" onClick={() => addFieldOption()}>追加</a>}
                                                {(editFieldOptionId === "" && checkedFiledOptionId) && <a className="btn btn-danger mr10" onClick={()=> removePartFieldOption()}>削除</a>}
                                            </div>
                                        </>
                                    }
                                         <table className="table table-bordered">
                                            <thead>
                                                <tr className="success">
                                                    <th className="col-md-8 col-sm-8 col-xs-8 text-center">回答選択名</th>
                                                    {viewInitOption.includes(partField.inputtype_kbn) && <th className="col-md-2 col-sm-2 col-xs-2 text-center">回答初期化</th>}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    fieldOptions.map((fieldOption) =>{
                                                        const isChecked = fieldOption.id === checkedFiledOptionId;
                                                        const isEdited = fieldOption.id === editFieldOptionId;
                                                        return(
                                                            <>
                                                                {
                                                                    (isEdited) ? (
                                                                        <tr className={isChecked && "select-part-group"} onClick={() => changeCheckedOptionId(fieldOption.id)}>
                                                                            <td>
                                                                                <input 
                                                                                    className="form-control" 
                                                                                    placeholder="オプション名" 
                                                                                    type="text" 
                                                                                    id="option_title" 
                                                                                    defaultValue={fieldOption.title}
                                                                                    onChange={(e) => setEditFieldOption({...editFieldOption, title: e.target.value})}
                                                                                />
                                                                            </td>
                                                                            {viewInitOption.includes(partField.inputtype_kbn) && (
                                                                                <td className="text-center">
                                                                                    <select className="form-control" id="m_part_field_option" onChange={(e) => setEditFieldOption({...editFieldOption, is_option_clear: Boolean(e.target.value)})}>
                                                                                        <option value={null}>しない</option>
                                                                                        <option value="true">する</option>
                                                                                    </select>
                                                                                </td>
                                                                            )}

                                                                        </tr>
                                                                    ):(
                                                                        <tr className={isChecked && "select-part-group"} onClick={() => !editFieldOptionId && changeCheckedOptionId(fieldOption.id)}>
                                                                            <td>{fieldOption.title}</td>
                                                                            { viewInitOption.includes(partField.inputtype_kbn) && (
                                                                                <td className="text-center">
                                                                                    {fieldOption.is_option_clear ? "する" : "しない" }
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    )
                                                                }

                                                            </>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                </div>
                            }
                            </div>
                        

                        <div className="modal-footer bg-success">
                            <div className="col-md-3 col-sm-3 col-xs-3">
                                {
                                    editPartFieldId === "" ? (
                                        <a className="btn btn-primary col-md-12 col-sm-12 col-xs-12" data-dismiss="modal">閉じる</a>
                                    ) : (
                                    <>
                                        <a className="btn btn-primary col-md-12 col-sm-12 col-xs-12" onClick={()=> closeModal()}>閉じる</a>
                                        <input type="hidden" id="close-modal" data-dismiss="modal"/>
                                    </>
                                        )
                                    
                                }
                            </div>

                            <div className="col-md-6 col-sm-6 col-xs-6"/>
                            
                            <div className="col-md-3 col-sm-3 col-xs-3">
                                {
                                    editPartFieldId === "" ? (
                                        <button
                                            type="button" 
                                            className="btn btn-primary col-md-12 col-sm-12 col-xs-12 active" 
                                            data-dismiss="modal" 
                                            onClick={() => addPartField()}>追加
                                        </button>
                                    ):(
                                        <button
                                            type="button" 
                                            className="btn btn-primary col-md-12 col-sm-12 col-xs-12 active" 
                                            data-dismiss="modal" 
                                            onClick={() => updatePartField()}>更新
                                        </button>
                                    )
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalPreview part={part} partFields={partFields}/>

        </>
    )
}
export default Index;